export default __webpack_public_path__ + "static/media/kids-4.f314bf12.jpeg";